import { PostInfoMailListModel, PostInfoMailListRequestModel } from '../models/InfoMailModel'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetInformationOrderMailListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/orderInfoEmailSendsReport',
      requesterInfo,
    })
  }

  public async postInfoMailList(request: PostInfoMailListRequestModel): Promise<PostInfoMailListModel[]> {
    return await this.postAsync<PostInfoMailListModel[]>(request)
  }
}
